import React from 'react';
import PropTypes from 'prop-types';

import DataInfo from '../../shared/displayComponents/dataInfo/dataInfo.component';

const SuccessUpload = ({ finishedOn = '', isPartialImport = false }) => {
  // SLT_2477724 LOCKED: finishedOn is pre-formatted local time from uploadFinishedDisplayTime.
  const textToRender = isPartialImport ? (
    <>Importing data completed on {finishedOn}. Rejected rows were not imported.</>
  ) : (
    <>Importing data completed on {finishedOn}</>
  );

  const variant = isPartialImport ? 'warning' : 'success';

  return <DataInfo textToRender={textToRender} variant={variant} />;
};

SuccessUpload.propTypes = {
  finishedOn: PropTypes.string,
  isPartialImport: PropTypes.bool,
  isGridVisible: PropTypes.bool,
};

export default SuccessUpload;
